import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  templateUrl: 'image-viewer.component.html',
  styleUrls: ['image-viewer.component.scss']
})
export class ImageViewerComponent {
  @Input()
  imageUrl: string;
  @Input()
  title: string;

  constructor(private modalCtrl: ModalController) {}

  close() {
    this.modalCtrl.dismiss();
  }
}
